import React from 'react';
import Form from 'react-bootstrap/Form';
import type { TenantSummary } from '../../services/types';

/** Props der TenantSelect-Komponente. */
export interface TenantSelectProps {
  /** Verfuegbare Mandanten (sortiert nach Name, siehe tenantService). */
  readonly tenants: readonly TenantSummary[];
  /** Gewaehlte Mandanten-ID oder null (keine Auswahl). */
  readonly selectedTenantId: string | null;
  /** Wird bei einer Auswahlaenderung aufgerufen. */
  readonly onChange: (tenantId: string | null) => void;
  /**
   * true, waehrend save()/remove() der KI-Konfiguration laeuft: Ein
   * Mandantenwechsel waehrend einer laufenden Mutation koennte deren
   * (verspaetete) Antwort auf den FALSCHEN Mandanten anwenden — die
   * Auswahl bleibt deshalb bis zum Abschluss gesperrt.
   */
  readonly disabled: boolean;
}

/** Wert der Platzhalter-Option ("Bitte wählen"). */
const PLACEHOLDER_VALUE = '';

/**
 * Mandanten-Auswahl (Dropdown) oberhalb des KI-Konfigurationsformulars.
 * Optionen zeigen Name und Slug ("Muster GmbH (muster-gmbh)").
 */
function TenantSelect({
  tenants,
  selectedTenantId,
  onChange,
  disabled,
}: TenantSelectProps): React.JSX.Element {
  return (
    <Form.Group id="ai-config-tenant-group" className="mb-3">
      {/*
        BEWUSST ohne `controlId` auf Form.Group: Zusammen mit einer
        eigenen `id` auf Form.Select erzeugt react-bootstrap sonst eine
        Konsolen-Warnung ("controlId is ignored on <FormLabel>..."). Die
        Verbindung Label/Control laeuft stattdessen ueber htmlFor, die
        HTML-ID des Selects bleibt unveraendert "ai-config-tenant-select".
      */}
      <Form.Label id="ai-config-tenant-label" htmlFor="ai-config-tenant-select">
        Mandant
      </Form.Label>
      <Form.Select
        id="ai-config-tenant-select"
        value={selectedTenantId ?? PLACEHOLDER_VALUE}
        disabled={disabled}
        onChange={(event) => {
          const value = event.target.value;
          onChange(value === PLACEHOLDER_VALUE ? null : value);
        }}
      >
        <option id="ai-config-tenant-option-placeholder" value={PLACEHOLDER_VALUE}>
          Bitte wählen…
        </option>
        {tenants.map((tenant) => (
          <option id={`ai-config-tenant-option-${tenant.id}`} key={tenant.id} value={tenant.id}>
            {`${tenant.name} (${tenant.slug})`}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}

export default TenantSelect;
